import Dexie from 'dexie';

export const dexie = new Dexie('userDatabase');
dexie.version(2).stores({
  posts: '++id, title, sub_title, image, hash, creation_time, network' // Primary key and indexed props
});